// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__kP+Ym","primary":"button_primary__Poqar","secondary":"button_secondary__fYx4K"};